import { Component, OnInit, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Workorder } from 'src/app/models/workorder';
import { WorkorderService } from 'src/app/services/workorder.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Swal from "sweetalert2";
@Component({
  selector: 'app-workorder-status-dialog',
  templateUrl: './workorder-status-dialog.component.html',
  styleUrls: ['./workorder-status-dialog.component.scss']
})
export class WorkorderStatusDialogComponent implements OnInit {

  className: string = '';
  loadWorkorderHistory: boolean = true;
  displayedColumns: string[] = ['STATUS_DESC', 'STATUSDATE', 'STATUSDATESYS', 'REASON_DESC', 'USER_ID', 'EXPORTDATE'];
  dataSource = new MatTableDataSource<Workorder>();
  statusData: any = [];
  radioOptions = [
    { label: 'View all', value: 'all', color: 'primary' },
    { label: 'Statuses', value: 'ST', color: 'orangered' },
    { label: 'Milestone', value: 'MS', color: 'darkgreen' }
  ];

  selectedRadioValue = 'all'; // default selection


  constructor(
    public dialogRef: MatDialogRef<WorkorderStatusDialogComponent>,
    private workorderService: WorkorderService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.className = data.panelClass;
  }

  ngOnInit() {
    this.loadWorkorderHistory = true;
    this.workorderService.getWorkorderData(this.data.workorderID).subscribe(res => {
      this.statusData = res.StatusHistory;
      this.dataSource.data = res.StatusHistory;
      this.loadWorkorderHistory = false;
    }, (err) => {
      this.loadWorkorderHistory = false;
      Swal.fire({
        text: "Error",
        icon: "error",
        confirmButtonText: "OK",
      });
    })
    // this.statusData = this.data;
    // this.dataSource.data = this.data;

  }

  /** simple close popup */
  closedialog() {
    this.dialogRef.close();
  }

  radioStatusChange(data: string) {
    if (data === 'ST' || data === 'MS') {
      this.dataSource.data = this.statusData.filter(status => status.TYPE_CD === data);
    } else {
      this.dataSource.data = this.statusData;
    }
  }

}
